import { render, staticRenderFns } from "./TriggerTraceDetail.vue?vue&type=template&id=33156979&scoped=true"
import script from "./TriggerTraceDetail.vue?vue&type=script&lang=js"
export * from "./TriggerTraceDetail.vue?vue&type=script&lang=js"
import style0 from "./TriggerTraceDetail.vue?vue&type=style&index=0&id=33156979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33156979",
  null
  
)

export default component.exports